
import axios, { AxiosResponse } from 'axios';

import { ImportLog, ImportInput, ImportMemberLog } from "../../interface/IImport";
import { ApiResponse } from "../../interface/IResponse";




async function getImportLogListFunction(): Promise<AxiosResponse<ApiResponse<ImportLog[]>>> {

    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Import/getImportList";

        const response: AxiosResponse<ApiResponse<ImportLog[]>> = await axios.get<ApiResponse<ImportLog[]>>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){
           
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
   }
}

async function uploadMembersImportCsvFunction(param: ImportInput): Promise<AxiosResponse<ApiResponse<string>>> {

    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Import/uploadMembersImportCsv";

        const response: AxiosResponse<ApiResponse<string>> = await axios.post<ApiResponse<string>>(apiUrl, param, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){
           
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
   }
}



async function uploadLoanImportCsvFunction(param: ImportInput): Promise<AxiosResponse<ApiResponse<string>>> {

    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Import/uploadLoanImportCsv";

        const response: AxiosResponse<ApiResponse<string>> = await axios.post<ApiResponse<string>>(apiUrl, param, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        console.log('response:: ', response);

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){
           
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
   }
}


async function getImportLogsListFunction(hangfireImportId: number): Promise<AxiosResponse<ApiResponse<ImportMemberLog[]>>> {

    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Import/getMemberImportLogsByHangfireImportId/" + hangfireImportId;

        const response: AxiosResponse<ApiResponse<ImportMemberLog[]>> = await axios.get<ApiResponse<ImportMemberLog[]>>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){
           
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
   }
}


const importService = {
    getImportLogList: getImportLogListFunction,
    uploadMembersImportCsv: uploadMembersImportCsvFunction,
    getImportLogsList: getImportLogsListFunction,
    uploadLoanImportCsv: uploadLoanImportCsvFunction
}

export default importService;